<template src="./openApi.template.html">
</template>

<script>
  import moment from 'moment';
  import * as axios from 'axios';
  import Vue from 'vue'


  import VirtualScroll from "../../reservations/reservationListVue/src/component/VirtualScroll.vue";
  import 'vue-virtual-infinite-scroll/dist/css/vue-virtual-infinite-scroll.css'

  import ExcelJS from 'exceljs';
  import { saveAs } from 'file-saver';
  

  Vue.component('virtual-list', VirtualScroll)

  export default {
    name: "openApi",
    props: [],

    data() {
      return {
        dateFormatToDisplay: 'utc',
        isDownloadBtnClicked: false,
        selectedLogItem: {},
        logDetailsPanel: false,
        logDetail: {},
        openApiRequestLogs: [],
        showResourcePathList: false,
        showResponseStatusList: false,
        selectedFilterColumn: null,
        filterResourcePathText: '',
        filterResponseStatusText: null,
        minDate: null,
        maxDate: null,
        openApiDateRange: { startDate: null, endDate: null },
        dateFormat: 'DD MMM YYYY',
        linkedCalendars: null,
        filterObj: {
          ResourcePaths: [],
          ResponseStatuses: [],
          openApiStartDate: null,
          openApiEndDate: null
        },
        viewSaveObject: {
          ResourcePaths: [],
          ResponseStatuses: [],
        },
        resourcePathList: [{ResourcePathName: 'postRates'}, {ResourcePathName: 'postAvailability'}, {ResourcePathName: 'postRestrictions'}, {ResourcePathName: 'createOrUpdateUnitInfo'}, {ResourcePathName: 'getReservationDetails'}, {ResourcePathName: 'postClientPMSConfirmationNumber'}],    
        responseStatusList: [{statusCode: '200'},{statusCode: '201'},{statusCode: '400'},{statusCode: '500'},],
        items: [],
        options: {
          scrollbars: true,
          interactiveScrollbars: true,
          probeType: 3,
          mouseWheel: true,
          mouseWheelSpeed: 1
        },
        viewAttrsChanged: false,
        scrlBtns: false,
        scrllCount: 50,
        variable: false,
        totalLength: null,
        pullDownTextObj: {
          trigger: 'Loading...',
          begin: 'Loading...',
          complete: 'There are no items',
          error: 'There is server error',
          refresh: 'Loading...'
        },
        loading: true,
        isGreyOut: false,
        toggleFilterPanel: false,
        linearProgress: false,
        pageNumber: 1,
        itemsPerPage: 20,
        indexCount: 0
      };
    },
    methods:{
      updateOpenApiDateValues(value) {
        this.filterObj.openApiStartDate = moment(value.startDate).format('DD MMM YYYY')
        this.filterObj.openApiEndDate = moment(value.endDate).format('DD MMM YYYY')
      },
      showLogDetailsPanel(eachLog){
        let vm=this;
        vm.logDetail = eachLog;
        this.logDetailsPanel = true;
        vm.selectedLogItem = eachLog
      },
      refreshBtnClicked() {
        let vm = this
        vm.items = [];
        vm.pageNumber = 1;
        let refreshBtnEl = document.getElementById('refreshBtn')
        refreshBtnEl.classList.add('btn-default-refresh1')

        setTimeout(() => {
          console.log('refreshBtnEl', refreshBtnEl)
          refreshBtnEl.classList.remove('btn-default-refresh1')
        }, 500)
        vm.getOpenAPIRequestLogsFnc()
      },
      getOpenAPIRequestLogsFnc() {
        console.log("getOpenAPIRequestLogsFnc is calling")
        let vm = this;

        if (vm.items.length == 0) {
          vm.loading = true;
        }
        else if (vm.items.length > 0) {
          vm.loading = false;
        }
        vm.$store.dispatch("dataRequestHandler",
            {
            key: "GetOpenAPIRequestLogs",
            params: {
              ModuleAction: "GetOpenAPIRequestLogs",
              PageNumber: vm.pageNumber,
              PageSize: vm.itemsPerPage,
              ResourcePath: vm.filterObj.ResourcePaths.map((each) => each.ResourcePathName).join(','),
              ResStatusCode: vm.filterObj.ResponseStatuses.map((each) => each.statusCode).join(','),
              FromDate: vm.filterObj.openApiStartDate,
              ToDate: vm.filterObj.openApiEndDate,
              IsDownload: null
            },
            callback: function (err, response) {
                if (err) {
                    console.log('GetOpenAPIRequestLogs error', err)
                    vm.loading = false;
                    return;
                }

                var itemsWrap = $("#tagScrollSection").width();
                var tagBtnGrp = $(".tagBtnGrp").width();
                var calcWidth = itemsWrap + 300;
                if (calcWidth >= tagBtnGrp) {
                  vm.scrlBtns = true;
                }
                else {
                  vm.scrlBtns = false;
                }

                if (response) {
                    console.log("GetOpenAPIRequestLogs", response, response[0][0].TotalRecords);
                    vm.totalLength = response[0][0].TotalRecords;
                    // vm.openApiRequestLogs = response[1];
                    if (vm.pageNumber === 1) {
                      let i = 1
                      vm.indexCount = 0;
                      let updateResponse = response[1].map(each => ({...each, index: i++ }))
                      vm.items.splice(0, vm.items.length, ...updateResponse);
                      console.log('vm.items', vm.items)
                      vm.$store.dispatch("toastr", {
                      type: "success",
                      header: "Success!",
                      message: "Rendered OpenAPI Request Logs Successfully!"
                    });
                    }
                    else if (vm.pageNumber > 1) {
                      vm.indexCount = vm.items.length + 1;
                      let updateResponse = response[1].map(each => ({...each, index: vm.indexCount++ }))
                      vm.items.splice(vm.items.length, 0, ...updateResponse);
                    }

                      console.log('vm.items', vm.items)

                    vm.loading = false;
                }
            }
        });
      },
      getMoreData($stateChange) {
        console.log('getMoreData is called')
        if (this.items.length >= this.totalLength) {
          $stateChange('complete')
        } else {
          setTimeout(() => {
            $stateChange('loaded')
          }, 1500)
          this.loading = false;
          this.pageNumber++;
          this.getOpenAPIRequestLogsFnc();
        }
      },
      refreshData($pullStateChange) {
        console.log('refreshData is calling');
        setTimeout(() => {
          this.items.splice(0)
          for (let i = 0; i < 50; i++) {
            this.items.push({
              text: i,
              id: i,

            })
          }
          $pullStateChange('complete')
        }, 1500)
      },
      showFilterByType(filterCol) {
        let vm = this;
        setTimeout(function () {
          vm.selectedFilterColumn = filterCol;
          if (filterCol == "resourcePath") {
            $("#resourcePathDropDown").show();
          } else if (filterCol == "responseStatus") {
            $("#responseStatusDropDown").show();
          }
        }, 10);
      },
      removeResourcePathFromFilter(resourcePathObj, event) {
        let vm = this;
        var index = vm.filterObj.ResourcePaths.indexOf(resourcePathObj);
        if (index > -1) {
          vm.filterObj.ResourcePaths.splice(index, 1);
        }
        vm.resourcePathList.push(resourcePathObj);
        if (event)
          event.stopPropagation();
      },
      removeResponseStatusFromFilter(statusObj, event) {
        let vm = this;
        var index = vm.filterObj.ResponseStatuses.indexOf(statusObj);
        if (index > -1) {
          vm.filterObj.ResponseStatuses.splice(index, 1);
        }
        vm.responseStatusList.push(statusObj);
        if (event)
          event.stopPropagation();
      },
      removeSelectedOpenApiDatesFromFilter(filterObj) {
        filterObj.openApiStartDate = null,
        filterObj.openApiEndDate = null,
        this.openApiDateRange.startDate = null,
        this.openApiDateRange.endDate = null,
        this.applyFilter();
      },
      deleteSelectedResourcePathFromFilter(index, resourceObj) {
        this.removeResourcePathFromFilter(resourceObj);
        this.viewSaveObject.ResourcePaths.splice(index, 1);
        this.applyFilter();
      },
      deleteSelectedResponseStatusFromFilter(index, statusObj) {
        this.removeResponseStatusFromFilter(statusObj);
        this.viewSaveObject.ResponseStatuses.splice(index, 1);
        this.applyFilter();
      },
      showResourcePathFnc() {
        this.showResourcePathList = true;
      },
      showResponseStatusFnc() {
        this.showResponseStatusList = true;
      },
      addResourcePathToFilter(resourcePathObj) {
        let vm = this;
        vm.filterObj.ResourcePaths.push(resourcePathObj);
        vm.filterResourcePathText = '';
        var index = vm.resourcePathList.indexOf(resourcePathObj);
        if (index > -1) {
          vm.resourcePathList.splice(index, 1);
        }
        vm.selectedFilterColumn = null;
      },
      addResponseStatusToFilter(statusObj) {
        let vm = this;
        vm.filterObj.ResponseStatuses.push(statusObj);
        vm.filterResponseStatusText = null;
        var index = vm.responseStatusList.indexOf(statusObj);
        if (index > -1) {
          vm.responseStatusList.splice(index, 1);
        }
        vm.selectedFilterColumn = null;
      },
      scrollRight: function () {
        var container = this.$el.querySelector("#tagScrollSection");
        var cnt = this.scrllCount++;
        container.scrollLeft = cnt;
        console.log("scroll counter before" + cnt);
        this.scrllCount = this.scrllCount + 50;
        console.log("scroll counter after" + cnt);
        this.scrollLeft = cnt;


      },
      scrollLeft: function () {

        var container = this.$el.querySelector(".scrollingTags");
        console.log("Inner width -" + container.clientWidth);
        if (this.scrllCount == -1) {
          var container = this.$el.querySelector("#tagScrollSection");
          container.scrollLeft = 0;
          console.log("If");
        } else {
          var container = this.$el.querySelector("#tagScrollSection");
          var cnt2 = this.scrllCount--;
          container.scrollLeft = cnt2;
          console.log("scroll counter before" + cnt2);
          this.scrllCount = this.scrllCount - 50;
          console.log("scroll counter after" + cnt2);
        }
      },
      applyFilter() {

        let vm = this;
        console.log("filterObj", vm.filterObj)
        console.log("GetIncomingMessages", new Date(this.filterObj.logsFilterStartDate), this.filterObj.logsFilterEndDate);

        vm.items = [];
        vm.pageNumber = 1;
        vm.toggleFilterPanel = false;
        vm.showResourcePathList= false;
        vm.showResponseStatusList = false;
        vm.viewSaveObject.ResourcePaths.splice(0, vm.viewSaveObject.ResourcePaths.length, ...vm.filterObj.ResourcePaths);
        vm.viewSaveObject.ResponseStatuses.splice(0, vm.viewSaveObject.ResponseStatuses.length, ...vm.filterObj.ResponseStatuses)
        if (vm.viewSaveObject.ResourcePaths.length > 1 || vm.viewSaveObject.ResponseStatuses.length > 1) {
          vm.viewAttrsChanged = true;
        } else {
          vm.viewAttrsChanged = false;
        }
        vm.getOpenAPIRequestLogsFnc();
      },
  
      selectColumn(column, event) {
        let vm = this;
      },

      closeFilter() {
        let vm = this;
        vm.toggleFilterPanel = false;
        vm.logDetailsPanel=false;
        vm.showResourcePathList= false;
        vm.showResponseStatusList = false;
      },

      clearAllFilters() {
        this.items = [];
        this.scrlBtns = false;
        this.viewAttrsChanged = false;
        this.showResourcePathList= false;
        this.showResponseStatusList = false;
        this.resourcePathList = [{ResourcePathName: 'postRates'}, {ResourcePathName: 'postAvailability'}, {ResourcePathName: 'postRestrictions'}, {ResourcePathName: 'createOrUpdateUnitInfo'}, {ResourcePathName: 'getReservationDetails'}, {ResourcePathName: 'postClientPMSConfirmationNumber'}];
        this.responseStatusList = [{statusCode: '200'},{statusCode: '201'},{statusCode: '400'},{statusCode: '500'},];
        this.filterObj = {
          ResourcePaths: [],
          ResponseStatuses: [],
          openApiStartDate: null,
          openApiEndDate: null
        };

        this.viewSaveObject = {
          ResourcePaths: [],
          ResponseStatuses: []
        },
        this.pageNumber = 1;
        this.itemsPerPage = 20;
        // after clearing the filters passing the date range as current day
        this.openApiDateRange.startDate = new Date(); 
        this.openApiDateRange.endDate = new Date();

        this.getOpenAPIRequestLogsFnc();
      },
      async downloadOpenApiList() {
        let vm = this;
        vm.isDownloadBtnClicked = true;
        vm.$store.dispatch("dataRequestHandler",
            {
            key: "GetOpenAPIRequestLogs",
            params: {
              ModuleAction: "GetOpenAPIRequestLogs",
              PageNumber: vm.pageNumber,
              PageSize: vm.itemsPerPage,
              ResourcePath: vm.filterObj.ResourcePaths.map((each) => each.ResourcePathName).join(','),
              ResStatusCode: vm.filterObj.ResponseStatuses.map((each) => each.statusCode).join(','),
              FromDate: vm.filterObj.openApiStartDate,
              ToDate: vm.filterObj.openApiEndDate,
              IsDownload: 1
            },
            callback: async function (err, response) {
                if (err) {
                    console.log('GetOpenAPIRequestLogs error', err)
                    vm.$store.dispatch("toastr", {
                      type: "error",
                      message: "Unable to download openAPI request logs!",
                      header: "Error",
                    });
                    vm.isDownloadBtnClicked = false;

                    return;
                }

                if (response) {
    
                      let i = 1
                      vm.indexCount = 0;
                      let updateResponse = response[0].map(each => ({...each, index: i++,  DATE: vm.formattedDate(each.CreatedDate) }))

                      console.log('updateResponse',  updateResponse)
                  
                      const data = updateResponse

                      // Create a new workbook and worksheet
                      const workbook = new ExcelJS.Workbook();
                      const worksheet = workbook.addWorksheet('Sheet1');

                      // Add header row with bold styling
                      worksheet.columns = [
                        { header: 'S.NO', key: 'index', width: 15 },
                        { header: 'LOG ID', key: 'LogID', width: 15 },
                        { header: 'RESOURCE PATH', key: 'ResourcePath', width: 25 },
                        { header: 'METHOD', key: 'ReqMethod', width: 15 },
                        { header: 'RESPONSE STATUS', key: 'ResStatusCode', width: 20 },
                        { header: 'DATE', key: 'DATE', width: 25 },
                        {header : 'REQUEST BODY',key:'ReqBody', width: 25 },
                        {header:'RESPONSE BODY',key :'ResBody',width:25}
                      ];

                      worksheet.getRow(1).font = { bold: true }; // Apply bold to the header row

                      // Add data rows
                      data.forEach((item) => {
                        const row = worksheet.addRow(item);

                        // Apply left-alignment to each cell in the row
                        row.eachCell((cell) => {
                          cell.alignment = { horizontal: 'left' }; // Align text to the left
                        });
                      });

                      // Generate Excel file as a blob
                      const buffer = await workbook.xlsx.writeBuffer();
                      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                      
                      // Save the file
                      saveAs(blob, 'openApiLogs List.xlsx');
                      
                      vm.$store.dispatch("toastr", {
                        type: "success",
                        header: "Success!",
                        message: "Downloaded All OpenAPI Request Logs Successfully!"
                      });
                      vm.isDownloadBtnClicked = false;
                }
            }
        });
      },
      formattedDate(dateString) {
        return moment(dateString).utc().format('DD MMM YYYY hh:mm:ss A')
      },
    },
    computed: {
      filteredResourcePathList() {
        let filteredList = this.resourcePathList.filter(each => each.ResourcePathName.toLowerCase().includes(this.filterResourcePathText.toLowerCase()));
        return filteredList
      }
    },
    watch: {
      
      items(newArr, oldArr) {
        console.log("items changed", oldArr, newArr);
      },
      dateFormatToDisplay() {
        this.loading = true; // Set loading to true
        setTimeout(() => {
          this.loading = false; // Set loading to false after 500ms
        }, 300); // 500ms delay
      },
    },
    mounted() {
      let vm =  this;
      vm.getOpenAPIRequestLogsFnc();
      $(document).click(function (e) {
        $(".form-control.searchResultsAmenities").hide();
        vm.selectedFilterColumn = null;
      })
    },
    components: {
  
    },
    beforeDestroy() {
     
    }
  };

</script>
<style scoped lang="scss">
.dateFormatSelect{
  width:fit-content;
  display: inline;
}
.tagBtnGrpAdjustment{
  min-width: calc(100vw - 470px);
}
.tagBtnGrp.btn-group{
  max-width: calc(100vw - 470px);
}
</style>